<template>
  <div>
    <v-row>
      <v-col>
        <h1>{{ $t("travelService.orderList") }}</h1>
      </v-col>
      <v-spacer />
      <div>
        <v-btn block color="accent" to="/travel-service/new">{{ $t("travelService.newOrder") }}</v-btn>
      </div>
    </v-row>
    <v-row>
      <v-col class="pr-2" md="3" cols="12">
        <v-text-field :placeholder="$t('global.search')" v-model="search" />
      </v-col>
      <v-col class="px-2" md="3" cols="12">
        <v-combobox :items="itemsFilterType" :label="$t('travelService.services')" :placeholder="$t('global.all')" multiple small-chips v-model="filterType" />
      </v-col>
      <v-spacer />
      <v-col class="pl-2" md="4" cols="12">
        <v-combobox
          :items="itemsFilterStatus"
          :label="$t('travelService.status')"
          :placeholder="$t('global.all')"
          multiple
          small-chips
          v-model="filterStatus"
        />
      </v-col>
      <v-col class="pl-2" md="2" cols="12">
        <v-row>
          <v-spacer />
          <v-checkbox v-model="createdByMyselfOnly" :label="$t('global.myselfOnly')" />
        </v-row>
      </v-col>
    </v-row>

    <order-list-data-table
      @changed="downloadList"
      :travel-service-orders="orders"
      @edit="val => $router.push('/travel-service/edit/' + val)"
      @choose-offer="val => $router.push('/travel-service/choose-offer/' + val)"
      @approval="val => $router.push('/travel-service/approval/' + val)"
      @booked="val => $router.push('/travel-service/booked/' + val)"
      @message="val => $router.push('/travel-service/item-details/' + val)"
    />
  </div>
</template>

<script>
import { itemsFilterStatus, itemsFilterType, serviceStatus, singleServiceOrderStatus } from "../../staticData/ServiceOrder";
import { allPropertyItemSearch } from "../../repository/filterOverAllProperty";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import OrderListDataTable from "../../components/TravelService/OrderListDataTable";

export default {
  name: "TravelServiceView",
  components: { OrderListDataTable },
  data: () => ({
    serviceStatus: serviceStatus,
    pagination: { sortBy: "created_at", descending: true },
    search: "",
    filterStatus: [],
    filterType: [],
    allOrders: [],
    createdByMyselfOnly: false
  }),
  created() {
    this.downloadList();
  },
  computed: {
    itemsFilterType,
    singleServiceOrderStatus,
    itemsFilterStatus,
    headers() {
      return [
        {
          text: this.$t("travelService.headers.createdAt"),
          value: "created_at"
        },
        {
          text: this.$t("travelService.headers.createdBy"),
          value: "created_by_name"
        },
        {
          text: this.$t("travelService.headers.services"),
          value: "param",
          sortable: false
        },
        {
          text: this.$t("travelService.headers.allOrderStatus"),
          value: "status"
        },
        { text: "", value: "actions", sortable: false }
      ];
    },
    orders() {
      let filteredOrders = this.allOrders.filter(v => {
        if (this.filterStatus.length === 0) return true;
        for (let status of this.filterStatus) {
          if (v.status === status.value) return true;
        }
        return false;
      });
      if (this.createdByMyselfOnly) {
        filteredOrders = filteredOrders.filter(v => v.created_by_id === this.$store.getters["userProperties"].user_id);
      }
      if (this.filterType.length > 0) {
        filteredOrders = filteredOrders.filter(v => {
          for (let type of this.filterType) {
            for (let travelServiceItem of v.travel_service_items) {
              if (travelServiceItem.type === type.value) {
                return true;
              }
            }
          }
          return false;
        });
      }
      filteredOrders = filteredOrders.filter(v => allPropertyItemSearch(v, this.search));

      return filteredOrders;
    }
  },
  methods: {
    downloadList() {
      this.axios.get("/travel-service/get-service-order-list").then(resp => {
        this.allOrders = resp.data;
      });
    },
    filterOverAllProperty: filterOverAllProperty
  }
};
</script>

<style scoped></style>
